export default "/images/vendor/flag-icon-css/flags/4x3/vc.svg?e19034240ae39be40a4c1ce9a31b3ba7";